'use client';

import { BreadcrumbsFragment, MagazineLinks } from '@business/gql/graphql';
import { ArrowLeftIcon } from 'lucide-react';
import { useRouter } from 'next/navigation';

export default function BreadcrumbsBackButton({
  to,
  back,
}: {
  to?: BreadcrumbsFragment | MagazineLinks;
  back?: string;
}) {
  const router = useRouter();
  const onClick = () => {
    if (sessionStorage.getItem('previousPath')) {
      window.history.back();
    }
    if (to?.slug) return router.push(to.slug);
    window.history.back();
  };
  return (
    <button
      className="border-grey-150 mr-2 inline-flex content-center items-center gap-0.5 border bg-white px-1.5 py-1 text-black transition-colors duration-150 hover:border-black hover:text-black"
      onClick={onClick}>
      <ArrowLeftIcon className="h-4 w-4 max-lg:text-black" />
      {back}
    </button>
  );
}
